// removed by extract-text-webpack-plugin
module.exports = {"formWrap":"qempo_EditFlight_formWrap-2Xo_pg-","loading":"qempo_EditFlight_loading-2S6OZ2s"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/edit-flight/components/EditFlight.scss
// module id = 1446
// module chunks = 0